import { render, staticRenderFns } from "./tab6.vue?vue&type=template&id=cdd80318&scoped=true&"
import script from "./tab6.vue?vue&type=script&lang=js&"
export * from "./tab6.vue?vue&type=script&lang=js&"
import style0 from "./tab6.vue?vue&type=style&index=0&id=cdd80318&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd80318",
  null
  
)

export default component.exports